// src/api/client.ts
const API_BASE = "";

function Fetch(path, options) {
  if (path != null) {
    return fetch(`${API_BASE}${path}`, {
      credentials: "include",
      ...options,
    });
  }
}

export default Fetch;
